// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { DataProvider } from "./context/DataContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ToastContainer from "./components/Toast";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import Leadership from "./pages/Leadership";
import LeaderDetail from "./pages/LeaderDetail";
import { BRAND } from "./utils/constants";

function Layout() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin" element={<Admin />} />
      </Routes>
    );
  }

  return (
    <>
      <Navbar />
      <main id="main-content">
        <Routes>
          <Route path="/"               element={<Home />} />
          <Route path="/about"          element={<About />} />
          <Route path="/products"       element={<Products />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          <Route path="/contact"        element={<Contact />} />
          <Route path="/leadership" element={<Leadership />} />
          <Route path="/leadership/:slug" element={<LeaderDetail />} />
          <Route path="*"               element={<NotFound />} />
        </Routes>
      </main>
      <Footer />

      {/* WhatsApp floating button */}
      <a
        href={`https://wa.me/${BRAND.whatsappNumber}`}
        className="whatsapp-float"
        target="_blank"
        rel="noreferrer"
        title="Chat on WhatsApp"
        aria-label="Chat on WhatsApp"
      >
        💬
      </a>
    </>
  );
}

function NotFound() {
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 20,
      paddingTop: "var(--nav-height)",
      fontFamily: "var(--font-body)",
      textAlign: "center",
      padding: "var(--nav-height) 24px 40px",
    }}>
      <span style={{ fontSize: 72 }}>🌿</span>
      <h1 style={{ fontFamily: "var(--font-display)", color: "var(--forest)", fontSize: 40 }}>
        Page Not Found
      </h1>
      <p style={{ color: "var(--text-mid)", fontSize: 16, maxWidth: 400 }}>
        The page you're looking for doesn't exist. Let's get you back on track.
      </p>
      <a href="/" className="btn btn-primary" style={{ marginTop: 8 }}>← Back to Home</a>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <DataProvider>
          <ScrollToTop />
          <ToastContainer />
          <Layout />
        </DataProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
